/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 老项目域名地址
 * khglUrl: 客户管理域名地址
 * dicUrl : 字典服务器地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * welUrl :默认欢迎页
 *
 */
console.log(2)
let urls = {
  baseUrl:configUrl.baseUrl,
  apiLink: configUrl.apiLink,
  imgLink: configUrl.imgLink,
  indexLink:'/index/index.html'
};

const iconfontVersion = ['567566_r22zi6t8noas8aor', '599693_0b5sleso3f1j1yvi', '667895_xte3dcfrvbo6r', '667895_wd5z7hndeh8']
const iconfontUrl = `/cdn/t/font_$key.css`
const codeUrl = `/code`
// if (process.env.NODE_ENV === 'development') {
//   urls.baseUrl = configUrl.baseUrl
//   urls.apiLink = configUrl.apiLink
//   urls.imgLink =  configUrl.imgLink
// } else if (process.env.NODE_ENV === 'production') {
//   urls.baseUrl = configUrl.baseUrl
//   urls.apiLink = configUrl.apiLink
//   urls.imgLink = configUrl.imgLink
// }

function getImgLink(link){
  return urls.imgLink+link;
}
function apiLink(link){
  return urls.apiLink+link;
}
function getImgLinksplit(link){
  return link.replace(urls.imgLink,'');
}

export {
  urls,
  iconfontUrl,
  iconfontVersion,
  codeUrl,
  getImgLink,
  getImgLinksplit,
  apiLink
}
